module.exports = __webpack_public_path__ + "static/img/cont48 (6).6df8912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (6).jpg
// module id = rfwF
// module chunks = 0